export const billingMicroserviceUrl = 'https://telemetry.blinkelectrics.co.ke/billing';